import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'

import SubscribedComponent from './components/subscribed_component.js';

// import Error404 from './pages/error_404.js'
import Home from './pages/home.js'
import Login from './pages/login.js'
import Join from './pages/join.js'
import Account from './pages/account.js'
import Loading from './pages/loading.js'
import BuyPremium from './pages/buy_premium.js'
import WreckMap from './pages/wreck_map.js'
import PendingVerification from './pages/pending_verification.js'
import EmailConfirmed from './pages/email_confirmed.js'
import PurchasePending from './pages/purchase_pending.js'
import PurchaseConfirmed from './pages/purchase_confirmed.js'

import EmptyLayoutWrapper from './layouts/empty_layout.js';
import LoggedInLayoutWrapper from './layouts/logged_in_layout.js';
import LoggedOutLayoutWrapper from './layouts/logged_out_layout.js';
import PendingLayoutWrapper from './layouts/pending_layout.js';
import PremiumLayoutWrapper from './layouts/premium_layout.js';

const LayoutRoute = ({ component, layout, ...rest }) => {
  const TheComponent = component
  return (<Route {...rest} render={(props) => <TheComponent layout={layout} {...props} />} />)
}

class Routes extends SubscribedComponent {
  render() {
    if (this.emotyPermissions()) {
      // Loading Permissions
      return (
        <Switch>
          <LayoutRoute component={Loading} layout={EmptyLayoutWrapper} />
        </Switch>
      )
    } else if (this.hasPermission('wreck_details')) {
      // Premium
      return (
        <Switch>
          <LayoutRoute exact path='/account'   component={Account}             layout={PremiumLayoutWrapper} />
          <LayoutRoute exact path='/wrecks'    component={WreckMap}            layout={PremiumLayoutWrapper} />
          <LayoutRoute exact path='/welcome'   component={PurchaseConfirmed}   layout={PremiumLayoutWrapper} />
          <LayoutRoute exact path='/confirmed' component={EmailConfirmed}      layout={PremiumLayoutWrapper} />
          <Redirect to="/wrecks" />
        </Switch>
      )

    } else if (this.hasPermission('wreck_previews')) {
      // Logged In
      return (
        <Switch>
          <LayoutRoute exact path='/buy'       component={BuyPremium}          layout={LoggedInLayoutWrapper} />
          <LayoutRoute exact path='/buy/:id'   component={PurchasePending}     layout={LoggedInLayoutWrapper} />
          <LayoutRoute exact path='/welcome'   component={BuyPremium}          layout={LoggedInLayoutWrapper} />
          <LayoutRoute exact path='/account'   component={Account}             layout={LoggedInLayoutWrapper} />
          <LayoutRoute exact path='/wrecks'    component={WreckMap}            layout={LoggedInLayoutWrapper} />
          <LayoutRoute exact path='/confirmed' component={EmailConfirmed}      layout={LoggedInLayoutWrapper} />
          <Redirect to="/wrecks" />
        </Switch>
      )

    } else if (this.hasPermission('account_pending_verification')) {
      // Pending email verification
      return (
        <Switch>
          <LayoutRoute exact path='/pending'   component={PendingVerification} layout={PendingLayoutWrapper} />
          <LayoutRoute exact path='/confirmed' component={EmailConfirmed}      layout={PendingLayoutWrapper} />
          <Redirect to="/pending" />
        </Switch>
      )

    } else {
      // Logged Out
      return (
        <Switch>
          <LayoutRoute exact path='/'          component={Home}                layout={LoggedOutLayoutWrapper} />
          <LayoutRoute exact path='/login'     component={Login}               layout={LoggedOutLayoutWrapper} />
          <LayoutRoute exact path='/join'      component={Join}                layout={LoggedOutLayoutWrapper} />
          <LayoutRoute exact path='/confirmed' component={EmailConfirmed}      layout={LoggedOutLayoutWrapper} />
          <Redirect to="/" />
        </Switch>
      )
    }
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js